import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

import {
  FormArray,
  FormGroup,
  ReactiveFormsModule,
  FormsModule
} from '@angular/forms';

import { debounceTime, distinctUntilChanged } from 'rxjs/operators';

import { MatFormFieldModule }
from '@angular/material/form-field';

import { MatInputModule }
from '@angular/material/input';

import { MatSelectModule }
from '@angular/material/select';

import { MatOptionModule }
from '@angular/material/core';

import { MatButtonModule }
from '@angular/material/button';

import { MatIconModule }
from '@angular/material/icon';

import { DynamicFieldConfig, EntityTaxConfig }
from '../../../../core/models/dynamic-form.models';

import { DynamicFieldService }
from '../../../../core/services/dynamic-field.service';

import { TaxRuntimeService }
from '../../../../core/services/system/tax-runtime.service';

import { TaxPreviewService }
from '../../../../core/services/system/tax-preview.service';

import { SWDynamicAutocompleteComponent }
from '../../sw-autocomplete/sw-autocomplete.component';

import {
  MatDialog,
  MatDialogModule
} from '@angular/material/dialog';

import { TaxDialogComponent }
from '../../tax-dialog/tax-dialog.component';

import {LineCellTextComponent}from '../line-cell/line-cell-text/line-cell-text.component';
import {LineCellSelectComponent}from '../line-cell/line-cell-select/line-cell-select.component';
import {LineCellAutocompleteComponent}from '../line-cell/line-cell-autocomplete/line-cell-autocomplete.component';
import {LineCellMoneyComponent}from '../line-cell/line-cell-money/line-cell-money.component';
import {LineCellNumberComponent}from '../line-cell/line-cell-number/line-cell-number.component';
import {LineCellTaxComponent}from '../line-cell/line-cell-tax/line-cell-tax.component';
import {LineCellDateComponent}from '../line-cell/line-cell-date/line-cell-date.component';
import { ExpressionEvaluatorService } from '../../../../core/services/system/expression-evaluator.service';

declare var KTDrawer: any;
@Component({
  selector: 'app-line-items-table',
  standalone: true,

  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    MatOptionModule,
    MatButtonModule,
    MatIconModule,
    SWDynamicAutocompleteComponent,
    LineCellTextComponent,
    LineCellSelectComponent,
    LineCellAutocompleteComponent,
    LineCellMoneyComponent,
    LineCellNumberComponent,
    LineCellTaxComponent,
    LineCellDateComponent,
  ],

  templateUrl:
    './line-items-table.html'
})
export class LineItemsTableComponent
implements OnInit {

  // =========================================================
  // INPUTS
  // =========================================================

  @Input()
  formArray!: FormArray<FormGroup>;

  @Input()
  columns: DynamicFieldConfig[] = [];

  @Input()
  config!: DynamicFieldConfig;

  @Input()
  form!: FormGroup;

  @Input()
  layout: any;

  // =========================================================
  // CTOR
  // =========================================================
  private attachedRows = new WeakSet<FormGroup>();
  private taxCfg!: EntityTaxConfig;
  private initializedRows = new WeakSet<FormGroup>();

  constructor(
    private dfs: DynamicFieldService,

    private taxRuntime: TaxRuntimeService,

    private taxPreview: TaxPreviewService,
    private expressionEvaluator: ExpressionEvaluatorService,

    private dialog: MatDialog
  ) {}

  // =========================================================
  // INIT
  // =========================================================

  ngOnInit(): void {
    console.log(
      'COLUMN CONFIG',
      this.columns
    );

    this.taxCfg =this.dfs.getTaxConfig(this.layout);

    this.attachAllRows();

    // this.formArray.valueChanges
    //   .pipe(
    //     debounceTime(50)
    //   )
    //   .subscribe(() => {

    //     this.attachAllRows();
    //   });

    this.refreshDocumentTotals();
  }

  ngAfterViewInit(): void {

    this.initializeExistingRows();

  }

  // =========================================================
  // ADD ROW
  // =========================================================

  addRow(): void {
    const row =
      this.dfs.createRepeaterRow(
        this.layout,
        this.config.name
      );

    this.formArray.push(row);
    console.log(
      'ROW CONTROLS',
      Object.keys(
        row.controls
      )
    );

    this.initializeRow(row);

    this.refreshDocumentTotals();
  }

  // =========================================================
  // REMOVE ROW
  // =========================================================

  removeRow(index: number): void {

    this.formArray.removeAt(index);

    this.refreshDocumentTotals();
  }

  // =========================================================
  // TAX RUNTIME ATTACH
  // =========================================================

  private attachTaxRuntime(
    row: FormGroup
  ): void {

    console.log(
      'ATTACH TAX RUNTIME EXECUTED'
    );
    if (
      this.attachedRows.has(row)
    ) {
      return;
    }

    this.attachedRows.add(row);
    // ==========================================
    // ITEM CHANGE
    // ==========================================

    console.log('role item value', this.role('item'));
    row.get(this.role('item'))
      ?.valueChanges
      .subscribe(item => {

        if (!item) {
          return;
        }

        console.log(
          'ITEM VALUE CHANGED',
          item
        );

        this.resolveRuntimeTax(row);
      });

    // ==========================================
    // RECALCULATION TRIGGERS
    // ==========================================

    this.taxCfg.triggers.recalculate
    .map(r =>
      this.taxCfg.roles[r]
    ).forEach(field => {

      row.get(field)
        ?.valueChanges
        .pipe(
          debounceTime(300),
          distinctUntilChanged()
        )
        .subscribe(() => {
          
          console.log(
            'RECALC TRIGGER',
            field
          );

          this.previewTaxes(row);
        });
    });

    //
    row.get(this.role('taxGroup'))
      ?.valueChanges
      .subscribe(v => {

        console.log(
          'TAX GROUP RAW VALUE',
          v
        );

        if (!v) {
          return;
        }

        const taxGroupId =
          typeof v === 'object'
            ? (v.id ?? v.value)
            : v;

        row.patchValue({
          [this.role('taxGroupId')]:
            taxGroupId
        },{
          emitEvent:false
        });

        //this.previewTaxes(row);

      });
  }

  // =========================================================
  // RESOLVE TAX GROUP
  // =========================================================

  private resolveRuntimeTax(
    row: FormGroup
  ): void {

    console.log(
      'RESOLVE RUNTIME TAX',
      row.getRawValue()
    );
    const cfg = this.taxCfg;

      const payload = {

         orgId:
          this.getId(
            this.form.get(
              this.role('organization')
            )?.value
          ),

        customerId:
          this.getId(
            this.form.get(
              this.role('customer')
            )?.value
          ),

        currencyId:
          this.getId(
            this.form.get(
              this.role('currency')
            )?.value
          ),

        itemId:
        this.getId(
          row.get(
            this.role('item')
          )?.value
        ),

        transactionType: cfg.runtime.transactionType
      };

    console.log(
      'RUNTIME PAYLOAD',
      payload
    );
    this.taxRuntime
      .resolve(payload)
      .subscribe({

        next: (res: any) => {
          console.log(
            'Tax Runtime Result',
            res
          );
          if (!res?.success) {
            return;
          }

          row.patchValue({

            [this.role('taxGroupId')]:
              res.data.taxGroupId,

            [this.role('taxGroup')]: {

              id:
                res.data.taxGroupId,

              label:
                res.data.taxGroupName
            }

          },{
            emitEvent:false
          });
          
          console.log(
            'AFTER TAX PATCH',
            row.getRawValue()
          );
          // ====================================
          // BACKEND PREVIEW
          // ====================================

           this.previewTaxes(row);
        },

        error: err => {

          console.error(
            'Tax runtime error',
            err
          );
        }
      });
  }
  private getId(value: any): any {

    if (!value) {
      return null;
    }

    if (typeof value === 'object') {
      return value.id ?? value.value ?? null;
    }

    return value;
  }

  // =========================================================
  // BACKEND TAX PREVIEW
  // =========================================================

  private previewTaxes(
    row: FormGroup
  ): void {

    console.log(
      'PREVIEW TAX CALLED',
      row.getRawValue()
    );

    const qty =
      Number(
        row.get(this.role('quantity'))
          ?.value || 0
      );

    const unitPrice =
      Number(
        row.get(this.role('unitPrice'))
          ?.value || 0
      );

    console.log( "get row values for tax preview",
      row.getRawValue()
    );
    console.log(
      'Preview Inputs',
      {
        qty,
        unitPrice,
        taxGroup:
          row.get(this.role('taxGroupId'))
            ?.value
      }
    );
    
    const taxGroupId =
      row.get(
        this.role('taxGroupId')
      )?.value;

      console.log(
        'PREVIEW VALUES',
        JSON.stringify({
          qty,
          unitPrice,
          taxGroupId,
          row: row.getRawValue()
        })
      );

    if (
      qty <= 0 ||
      unitPrice <= 0 ||
      !taxGroupId
    ) {

      console.log(
        'PREVIEW SKIPPED',
        {
          qty,
          unitPrice,
          taxGroupId
        }
      );

      return;
    }

    const line =
      row.getRawValue();

    // ==========================================
    // CALL BACKEND
    // ==========================================

    if (!taxGroupId) {

      console.log(
        'PREVIEW WAITING FOR TAX GROUP'
      );

      return;
    }

    this.taxPreview
      .preview(
        this.layout.entity,
        this.form.getRawValue(),
        line
      )
      .subscribe({

        next: (res: any) => {

          console.log(
            'TAX PREVIEW RESPONSE',
            JSON.stringify(res)
          );

          row.patchValue({

            [this.role('baseAmount')]:
              res.baseAmount,

            [this.role('taxAmount')]:
              res.taxAmount,

            [this.role('grossAmount')]:
              res.grossAmount,

            [this.role('taxLines')]:
              res.taxes || []

          }, {
            emitEvent: false
          });

          console.log(
            'ROW AFTER TAX PATCH',
            JSON.stringify(
              row.getRawValue()
            )
          );

          this.refreshDocumentTotals();
        },

        error: err => {

          console.error(
            'TAX PREVIEW ERROR',
            err
          );
        }

      });
  }

  // =========================================================
  // REFRESH HEADER TOTALS
  // =========================================================

  private refreshDocumentTotals(): void {
    console.log(
      'REFRESH DOCUMENT TOTALS'
    );
  let subtotal = 0;
  let taxTotal = 0;

  this.formArray.controls
    .forEach(row => {

      subtotal += Number(
        row.get(
          this.role('baseAmount')
        )?.value || 0
      );

      taxTotal += Number(
        row.get(
          this.role('taxAmount')
        )?.value || 0
      );
    });

  this.form.patchValue({

    [this.role('subtotal')]:
      subtotal,

    [this.role('taxTotal')]:
      taxTotal,

    [this.role('grandTotal')]:
      subtotal + taxTotal

  },{
    emitEvent:false
  });
}

  // =========================================================
  // TAX POPUP
  // =========================================================

  openTaxDialog(
    row: FormGroup
  ): void {

    console.log(
      'OPEN TAX DIALOG',
      row.get(
        this.role('taxLines')
      )?.value
    );

    this.dialog.open(
      TaxDialogComponent,
      {
        width: '900px',

        data: {

          lineTotal:
            row.get(
              this.role('baseAmount')
            )?.value,

          taxLines:
            row.get(
              this.role('taxLines')
            )?.value || []

        }
      }
    );
  }

  // =========================================================
  // HELPERS
  // =========================================================

  trackByIndex(
    index: number
  ): number {

    return index;
  }

  getControl(
    row: FormGroup,
    fieldName: string
  ) {

    return row.get(fieldName);
  }

  // =========================================================
  // DISPLAY LABEL
  // =========================================================

  getDisplayLabel(
    row: FormGroup,
    col: DynamicFieldConfig
  ): string {

    const ctrl =
      row.get(col.name);

    if (!ctrl) {
      return '';
    }

    return ctrl.value || '';
  }

  // =========================================================
  // VALIDATION MESSAGE
  // =========================================================

  getError(
    row: FormGroup,
    col: DynamicFieldConfig
  ): string {

    const ctrl =
      row.get(col.name);

    if (!ctrl || !ctrl.errors) {
      return '';
    }

    if (ctrl.errors['required']) {
      return `${col.label} is required`;
    }

    if (ctrl.errors['min']) {
      return `Minimum value invalid`;
    }

    if (ctrl.errors['max']) {
      return `Maximum value exceeded`;
    }

    if (ctrl.errors['softMax']) {

      const err =
        ctrl.errors['softMax'];

      return err?.max
        ? `${col.label} cannot exceed ${err.max}`
        : `Maximum exceeded`;
    }

    if (ctrl.errors['pattern']) {
      return `Invalid format`;
    }

    return 'Invalid value';
  }

  isColumnVisible(
    col: DynamicFieldConfig,
    row?: FormGroup
  ): boolean {

    if (col.type === 'hidden')
      return false;

    const expr =
      (col as any).visibleIf;

    if (!expr)
      return true;

    return this.expressionEvaluator.evaluate(
      expr,
      {
        header: this.form.getRawValue(),

        line:
          row?.getRawValue() || {}
      }
    );
  }

  private attachAllRows(): void {

  this.formArray.controls.forEach(ctrl => {

    const row =
      ctrl as FormGroup;

    this.initializeRow(row);

  });

}

  private role(
    name: string
  ): string {

    return (
      this.taxCfg.roles?.[name]
      ?? name
    );

  }

  private initializeRow(
  row: FormGroup
  ): void {

    if (
      this.initializedRows.has(row)
    ) {
      return;
    }

    this.initializedRows.add(row);

    console.log(
      'INITIALIZE ROW'
    );

    this.attachTaxRuntime(row);

  }

  private initializeExistingRows(): void {

    const arr =this.form.get( this.config.name ) as FormArray;

    if (!arr) {
      return;
    }

    arr.controls.forEach(ctrl => {

      this.initializeRow(
        ctrl as FormGroup
      );

    });

  }

  openTaxDrawer(): void {
    const el = document.querySelector('#drawer_tax_breakdown') as HTMLElement;
    const drawer = KTDrawer.getInstance(el) || new KTDrawer(el);
    drawer.show();
  }

  closeTaxDrawer(): void {
    const el = document.querySelector('#drawer_tax_breakdown') as HTMLElement;
    const drawer = KTDrawer.getInstance(el);
    drawer?.hide();
  }

}